import RGBToHSL from "../converters/RGBToHSL.js";
import hexToRGB from "../converters/hexToRGB.js";
import HSLToRGB from "../converters/HSLToRGB.js";
import RGBToHex from "../converters/RGBToHex.js";

/**
 * @typedef {object} generatedColors
 * @property {string} dark - dark color
 * @property {string} light - light color
 */

/**
 *
 * @param {string} hexColor rgb color in hex
 * @returns {generatedColors} object with light color and dark color
 * @description create object with light color and dark color.
 * it will use the color to decide with color to create
 * for example if you provide light color it will calc dark color
 * and will detect light/dark automatically
 */
const createDarkLightColors = (hexColor) => {
  const [r, g, b] = hexToRGB(hexColor);
  const [h, s, l] = RGBToHSL(r, g, b);
  let nL = 100 - l;
  if (nL >= 35 && nL <= 44) nL -= 15;
  if (nL >= 45 && nL <= 55) nL -= 35;
  if (nL >= 56 && nL <= 65) nL += 10;
  if (nL < 0) nL = 0;
  if (nL > 100) nL = 100;
  const [nr, ng, nb] = HSLToRGB(h, s, nL);
  let color1 = hexColor,
    color2 = RGBToHex(nr, ng, nb);
  if (l > nL) return { light: color1, dark: color2 };
  return { light: color2, dark: color1 };
};

export default createDarkLightColors;
